export const getDxAiPatientClinicMuiDialogActions = (palette: any) => ({
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "1.5rem",
        borderTop: `1px solid ${palette["outline-variant"].main}`,
        color: `${palette.primary}`,
      },
    },
  },
});
